import { DataType } from "ka-table"
import { TableColumn } from "../../../components/table/table"
import {  VIEW } from "../../../constant/commonConst"
import { getFormattedDate } from "../../../utils/dateUtils"
import LedgerReportPopup from "../ledgerReport/LedgerReportPopup"

export const columns = (actions: any): TableColumn[] => {
    return [
        {
            key: 'id',
            title: 'id',
            dataType: DataType.Number,
            visible: false
        },
        {
            key: 'businessName',
            title: 'business Name',
            dataType: DataType.String
        },
        {
            key: 'bookingDate',
            title: 'Booking Date',
            dataType: DataType.String,
            valueConvert: (rowData: any) => {
                return getFormattedDate(rowData)
            }
        },
        {
            key: 'bookingNo',
            title: 'booking No',
            dataType: DataType.String
        },
        {
            key: 'totalAmount',
            title: 'Total Booking Amount',
            dataType: DataType.String
        },
        {
            key: 'recivedAmount',
            title: 'Recived Amount',
            dataType: DataType.String
        },
        {
            key: 'balance',
            title: 'balance',
            dataType: DataType.String,
            valueConvert:(rowData:any)=>{
                return rowData.toFixed(2)
            }
        },
        {
            key: "edit",
            title: "",
            hideHeaderFilter: false,
            component: LedgerReportPopup,
            callBack: async (row) => {
                if (row.status === VIEW) {
                    actions.showModal({ ...row.data });
                }
            },
            
            style: {
                textAlign: "center",
            },
        },
    ]
}



export const LedgerPaymentReportColumn = (): TableColumn[] => {
    return [
        {
            key: 'id',
            title: 'id',
            dataType: DataType.Number,
            visible: false
        },
        {
            key: 'businessName',
            title: 'Business Name',
            dataType: DataType.String
        },
        {
            key: 'personName',
            title: 'Person Name',
            dataType: DataType.String,
            valueConvert:(rowData:any)=>{
                return rowData ?? "-"
            }
        },
        {
            key: 'paymentDate',
            title: 'Payment Date / Booking Date',
            dataType: DataType.String,
            valueConvert: (rowData: any,row:any) => {
                return rowData ? getFormattedDate(rowData) : getFormattedDate(row.bookingDate)
            }
        },
        {
            key: 'totalAmount',
            title: 'Total Booking Amount',
            dataType: DataType.String
        },
        {
            key: 'amount',
            title: 'Received Amount',
            dataType: DataType.String
        },
        {
            key: 'balance',
            title: 'Balance',
            dataType: DataType.String,
            valueConvert:(rowData:any,row:any)=>{
                return rowData.toFixed(2)
            }
        },
    ]
}